const colors = [
  { hex: "#EAE7DC", name: "Dusty White" },
  { hex: "#D8C3A5", name: "Sandstone" },
  { hex: "#E98074", name: "Sun-kissed" },
  { hex: "#8E8D8A", name: "Muted Sage" },
  { hex: "#4A3F35", name: "Deep Earth" },
];

const ColorPalette = () => {
  return (
    <section className="py-20 bg-dreamy-cream text-center">
      <p className="font-sans text-[10px] tracking-[0.4em] uppercase text-dreamy-earth/40 mb-10">
        Nature's Palette
      </p>
      <div className="flex flex-wrap justify-center gap-8 md:gap-16 px-6">
        {colors.map((color, i) => (
          <div key={i} className="flex flex-col items-center gap-3">
            <div
              className="w-12 h-12 md:w-16 md:h-16 rounded-full shadow-inner border border-white/50"
              style={{ backgroundColor: color.hex }}
            />
            <span className="font-sans text-[9px] tracking-widest uppercase text-dreamy-earth/60">
              {color.name}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ColorPalette;
